import * as type from '../../types/trans';

let init = {
    holdingName: {},
    holdingFolio: {},
    mohData: [],
    mohWiseData: {},
    folioData: [],
    folioWiseData: {},
    allData: [],
    karvyStatus: false,
}

export default function karvyFolioReducer(state = init, action) {
    switch (action.type) {

        case type.FOLIO_KARY_PENDING:
            return {
                ...state,
                karvyStatus: true

            }

        case type.FOLIO_KARY_SUCCESS:
            let { allData, mohData, mohWiseData, folioData, folioWiseData, holdingFolio, holdingName } = action.payload;


            return {
                ...state,
                holdingName: holdingName,
                holdingFolio: holdingFolio,
                mohData: mohData,
                mohWiseData: mohWiseData,
                folioData: folioData,
                folioWiseData: folioWiseData,
                allData: allData,
                karvyStatus: false,
            }

        case type.FOLIO_KARY_FAILED:


            return {
                ...state,
                holdingName: {},
                holdingFolio: {},
                mohData: [],
                mohWiseData: {},
                folioData: [],
                folioWiseData: {},
                allData: [],
                karvyStatus: false,
            }



        default:
            return state
    }
}